export const userCreationContants = {
  OPEN_FORM: "USER_CREATION_OPEN_FORM",
  CLOSE_FORM: "USER_CREATION_CLOSE_FORM",
  SET_USER_DATA: "USER_CREATION_SET_USER_DATA",
  CREATION_REQUEST: "USER_CREATION_REQUET",
  CREATION_SUCCESS: "USER_CREATION_SUCCESS",
  CREATION_FAILURE: "USER_CREATION_FAILURE"
};
